import { render } from "./SupplierClient.vue?vue&type=template&id=16936f41&scoped=true"
import script from "./SupplierClient.vue?vue&type=script&lang=js"
export * from "./SupplierClient.vue?vue&type=script&lang=js"

import "./SupplierClient.vue?vue&type=style&index=0&id=16936f41&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16936f41"]])

export default __exports__